"use strict";
var Dexie = require('dexie').default;
var DexieDb = (function () {
    function DexieDb() {
        try {
            this.db = new Dexie('author.today');
            this.db.version(1).stores({
                readingProgress: '++id, [userId+workId], chapterId, chapterProgress, workProgress, sessionId',
            });
        }
        catch (e) {
            console.log(e);
        }
    }
    return DexieDb;
}());
exports.DexieDb = DexieDb;
exports.IndexedDb = new DexieDb();
//# sourceMappingURL=indexedDbUtils.js.map